import { V2PaymentResponse } from '@api';
import { Stripe } from '@stripe/stripe-js';
import { IAction } from 'src/js/actions/IshAction';
import { State as PaymentState } from 'src/js/enrol/containers/payment/reducers/State';
import { GABuilder } from 'src/js/services/CommonAnalyticsService';
import { Phase } from '../../../reducers/State';
import { CorporatePassFormValues } from '../services/PaymentService';

export const SUBMIT_PAYMENT_CORPORATE_PASS = 'checkout/payment/submit/corporatePass';
export const SUBMIT_PAYMENT_FOR_WAITING_COURSES = 'checkout/payment/submit/waitingCourses';

export const CHECKOUT_RESET_PAYMENT_SESSION = 'checkout/v2/update/payment/session';

export const CHECKOUT_PROCESS_STRIPE_CC_PAYMENT = 'checkout/v2/process/stripe/payment';
export const CHECKOUT_PROCESS_SQUARE_CC_PAYMENT = 'checkout/v2/process/square/payment';
export const CHECKOUT_PROCESS_EWAY_CC_PAYMENT = 'checkout/v2/process/eway/payment';
export const CHECKOUT_COMPLETE_WINDCAVE_CC_PAYMENT = 'checkout/v2/complete/windcave/payment';
export const CHECKOUT_COMPLETE_STRIPE_CC_PAYMENT = 'checkout/v2/complete/stripe/payment';

export const PROCESS_PAYMENT_V2 = 'checkout/v2/payment/process/payment';
export const PROCESS_PAYMENT_V2_FAILED_STATUS = 'checkout/v2/payment/process/paymentStatus';

export const SET_PAYMENT_DATA = 'checkout/payment/set/paymentData';

export const SET_PAYMENT_FETCHING = 'checkout/payment/set/fetching';

export const SET_IFRAME_URL = 'checkout/payment/set/iframeUrl';

export const GENERATE_WAITING_COURSES_RESULT_DATA = 'checkout/payment/result/waitingCourses/data';

export const UPDATE_PAYMENT_STATUS = 'checkout/payment/update/payment/status';

export const GET_PAYMENT_STATUS = 'checkout/payment/get/payment/status';

export const RESET_PAYMENT_STATE = 'checkout/payment/reset/payment/state';
export const RESET_PAYMENT_STATE_ON_INIT = 'checkout/payment/reset/payment/onInit';

export const GET_CORPORATE_PASS_REQUEST = 'checkout/payment/get/corporatePass';
export const APPLY_CORPORATE_PASS = 'checkout/payment/apply/corporatePass';
export const RESET_CORPORATE_PASS = 'checkout/payment/reset/corporatePass';

export const CHANGE_TAB = 'checkout/payment/change/tab';

export const PROCESSING_MANDATORY_FIELDS = 'checkout/payment/processing/mandatoryFields';

export const submitPaymentForWaitingCourses = (): IAction<any> => {
  return {
    type: SUBMIT_PAYMENT_FOR_WAITING_COURSES
  };
};

export const submitPaymentCorporatePass = (values: CorporatePassFormValues): IAction<CorporatePassFormValues> => {
  return {
    type: SUBMIT_PAYMENT_CORPORATE_PASS,
    payload: values,
  };
};

export const setPaymentFetching = (fetching: PaymentState['fetching']): IAction<PaymentState['fetching']> => ({
  type: SET_PAYMENT_FETCHING,
  payload: fetching
})

export const processPaymentV2 = () => ({
  type: PROCESS_PAYMENT_V2
})

export const checkoutResetPaymentSession = () => ({
  type: CHECKOUT_RESET_PAYMENT_SESSION
})

export const checkoutProcessStripeCCPayment = (
  stripePaymentMethodId: string,
  stripe: Stripe
) => ({
  type: CHECKOUT_PROCESS_STRIPE_CC_PAYMENT,
  payload: {
    stripePaymentMethodId,
    stripe
  }
});

export const checkoutProcessSquareCcPayment = (
  creditCardToken: string,
  verificationToken: string,
) => ({
  type: CHECKOUT_PROCESS_SQUARE_CC_PAYMENT,
  payload: {
    creditCardToken,
    verificationToken
  }
});

export const checkoutCompleteWindcaveCcPayment = (
  paymentSessionId: string
) => ({
  type: CHECKOUT_COMPLETE_WINDCAVE_CC_PAYMENT,
  payload: { paymentSessionId }
});

export const checkoutCompleteStripeCcPayment = () => ({
  type: CHECKOUT_COMPLETE_STRIPE_CC_PAYMENT
});

export const checkoutProcessEwayCCPayment = (
  eWaySecureFieldCode: string
) => ({
  type: CHECKOUT_PROCESS_EWAY_CC_PAYMENT,
  payload: { eWaySecureFieldCode }
});

export const getPaymentStatus = (): IAction<any> => {
  return {
    type: GET_PAYMENT_STATUS,
  };
};

export const updatePaymentStatus = (response: V2PaymentResponse): IAction<V2PaymentResponse> => {
  return {
    type: UPDATE_PAYMENT_STATUS,
    payload: response,
    meta: {
      analytics: GABuilder.purchaseItems(response),
    },
  };
};

export const resetPaymentState = () => {
  return {
    type: RESET_PAYMENT_STATE,
  };
};

export const resetPaymentStateOnInit = () => {
  return {
    type: RESET_PAYMENT_STATE_ON_INIT,
  };
};

export const generateWaitingCoursesResultData = data => {
  return {
    type: GENERATE_WAITING_COURSES_RESULT_DATA,
    payload: data,
  };
};

export const getCorporatePass = (code: string) => ({
  type: GET_CORPORATE_PASS_REQUEST,
  payload: code,
});

export const applyCorporatePass = pass => ({
  type: APPLY_CORPORATE_PASS,
  payload: pass,
});

export const resetCorporatePass = () => ({
  type: RESET_CORPORATE_PASS,
});

export const setPaymentData = (data: V2PaymentResponse) => ({
  type: SET_PAYMENT_DATA,
  payload: data,
});

export const changeTab = tab => ({
  type: CHANGE_TAB,
  payload: tab,
  meta: {
    analytics: GABuilder.setCheckoutStep(Phase.Payment, tab),
  },
});

export const processingMandatoryFields = () => ({
  type: PROCESSING_MANDATORY_FIELDS,
});

